import IconPicker from 'components/Widgets/IconPicker';

const IconTypeField = ({ item, disabled, setNewSelectItem, selectItem }) => {
  return (
    <IconPicker
      selected={
        { icon: { id: selectItem?.value, file: selectItem?.setting?.file } } ?? {
          icon: { id: 1 },
        }
      }
      onChange={(val) => {
        setNewSelectItem({
          value: val.icon.id,
          setting: {
            file: val.icon.file,
          },
        });
      }}
      item={item}
      disabled={disabled}
    />
  );
};

export default IconTypeField;
